import React from 'react';

import { Form, Select, Toggle as NacreToggle, InfoText } from '@weezevent/nacre';

import Style from './inputs.module.css';

export function GenericInput({ label, error, children }) {
    return (
        <Form.Field>
            {label && <Form.Label>{label}</Form.Label>}
            {children}
            {error && <Form.FieldErrors errors={[error]} />}
        </Form.Field>
    );
}

export function ListSelect({ label, error, children, loading, ...rest }) {
    return (
        <div>
            <GenericInput label={label} error={error} loading={loading}>
                <Select {...rest} />
            </GenericInput>
            {children}
        </div>
    );
}

export function Input({ label, error, ...rest }) {
    return (
        <GenericInput label={label} error={error}>
            <Form.Input {...rest} />
        </GenericInput>
    );
}

export function Toggle({ label, subtitle, ...rest }) {
    return (
        <div className={Style['toggle']}>
            <div>
                <InfoText subtitle={subtitle}>{label}</InfoText>
            </div>
            <div>
                <NacreToggle {...rest} />
            </div>
        </div>
    );
}
